import { create } from 'zustand';

// Filtro attivo del Feed AI:
// - none: nessun filtro (ultimi 15 giorni)
// - tag: solo mail associate a un tag
// - toReply: solo mail marcate "da rispondere"
export type FeedFilter =
  | { kind: 'none' }
  // tag: selezione MULTIPLA (OR): mail che hanno ALMENO uno dei tag scelti
  | { kind: 'tag'; tags: { tagId: string; label: string; color: string }[] }
  | { kind: 'category'; category: string }
  | { kind: 'toReply' }
  | { kind: 'spam' }
  | { kind: 'noSpam' };

interface MailState {
  selectedAccountId: string | null;
  selectedFolderId: string | null;
  selectedMessageId: string | null;
  feedFilter: FeedFilter;
  // Multi-selezione righe per azioni bulk (Set di message id)
  selectedIds: Set<string>;
  toggleSelected: (id: string) => void;
  setSelectedMany: (ids: string[], on: boolean) => void;
  clearSelected: () => void;
  composeOpen: boolean;
  addAccountOpen: boolean;
  setSelectedAccount: (id: string | null) => void;
  setSelectedFolder: (id: string | null) => void;
  setSelectedMessage: (id: string | null) => void;
  setFeedFilter: (f: FeedFilter) => void;
  setComposeOpen: (open: boolean) => void;
  setAddAccountOpen: (open: boolean) => void;
}

export const useMailStore = create<MailState>((set) => ({
  selectedAccountId: null,
  selectedFolderId: null,
  selectedMessageId: null,
  feedFilter: { kind: 'none' },
  selectedIds: new Set<string>(),
  toggleSelected: (id) =>
    set((st) => {
      const next = new Set(st.selectedIds);
      next.has(id) ? next.delete(id) : next.add(id);
      return { selectedIds: next };
    }),
  setSelectedMany: (ids, on) =>
    set((st) => {
      const next = new Set(st.selectedIds);
      for (const id of ids) on ? next.add(id) : next.delete(id);
      return { selectedIds: next };
    }),
  clearSelected: () => set({ selectedIds: new Set<string>() }),
  composeOpen: false,
  addAccountOpen: false,
  setSelectedAccount: (id) => set({ selectedAccountId: id }),
  setSelectedFolder: (id) => set({ selectedFolderId: id, selectedMessageId: null }),
  setSelectedMessage: (id) => set({ selectedMessageId: id }),
  setFeedFilter: (f) => set({ feedFilter: f }),
  setComposeOpen: (open) => set({ composeOpen: open }),
  setAddAccountOpen: (open) => set({ addAccountOpen: open }),
}));
